module.exports = __webpack_public_path__ + "static/img/6.9575b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/6.png
// module id = ua5n
// module chunks = 0